import { ClipboardList, ReceiptText, Trophy } from 'lucide-react'
import { NavLink } from 'react-router'
import { cn } from '@/lib/cn'

const TABS = [
  { to: 'picks', label: 'Picks', Icon: ClipboardList },
  { to: 'board', label: 'Board', Icon: Trophy },
  { to: 'ledger', label: 'Ledger', Icon: ReceiptText },
]

export default function TabBar({ base }: { base: string }) {
  return (
    <nav className="bg-navy fixed inset-x-0 bottom-0 z-30">
      <ul className="mx-auto flex max-w-md pb-[env(safe-area-inset-bottom)]">
        {TABS.map(({ to, label, Icon }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={`${base}/${to}`}
              className={({ isActive }) =>
                cn(
                  'flex flex-col items-center gap-1 py-3 transition-colors',
                  isActive ? 'text-white' : 'text-white/45 hover:text-white/75'
                )
              }
            >
              <Icon size={18} strokeWidth={2} aria-hidden />
              <span className="font-mono text-eyebrow tracking-[0.14em] uppercase">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
